// extracted by mini-css-extract-plugin
module.exports = {"activityCell":"activityCell__7bopw","content":"content__QZtYU","text":"text__YSEX4","date":"date__8Timv","tooltip":"tooltip__0LdF1","tooltipClassName":"tooltipClassName__5y-qE"};